import commonPageService from 'pcCommon/services/commonPageService';
import { IUserInfo } from 'globalCommon/services/getUserInfo';
import { syncRender } from 'globalCommon/services/syncRender';
const dialogEduGlobal = require('globalCommon/html/dialogEduGlobal.html');

import './reset.css';
import './btn-new.css';
import './style.css';
import './home-common.css';

(window as any).showEduTutorial = function () {
    const dialog = document.createElement('div');
    dialog.innerHTML = dialogEduGlobal;
    dialog.classList.add('pc');
    document.body.appendChild(dialog);
    dialog.querySelectorAll('.close-edu-global').forEach((element) => {
        (element as HTMLElement).onclick = () => {
            document.body.removeChild(dialog);
        };
    });
};

const init = () => {
    const cb = (userInfo: IUserInfo) => {
        const applyDesc = document.querySelector('.edu-apply-desc');
        /** 这句多语必须要用 ``，因为翻译结果中有单引号，也有双引号，导致代码解析不对 */
        applyDesc && (applyDesc.innerHTML = `たった2つのステップでUMU教育発展計画に参画でき、<span>無料教育版</span>の機能をお楽しみ頂けます`);
        if (userInfo?.teacher_info?.teacher_status === 6) {
            const certificationBtn = document.querySelector('.btn-certification') as HTMLElement;
            certificationBtn && (certificationBtn.style.display = 'none');
        }
    };
    commonPageService({ cb, renderAfter: syncRender });
};

init();
